/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePlanRequestDto
 */
export interface UpdatePlanRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequestDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequestDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequestDto
     */
    priority?: UpdatePlanRequestDtoPriorityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePlanRequestDto
     */
    active?: boolean;
    /**
     * Days ahead of due date when ticket generation may create a Preventive Ticket
     * @type {number}
     * @memberof UpdatePlanRequestDto
     */
    schedulingHorizonDays?: number;
}


/**
 * @export
 */
export const UpdatePlanRequestDtoPriorityEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;
export type UpdatePlanRequestDtoPriorityEnum = typeof UpdatePlanRequestDtoPriorityEnum[keyof typeof UpdatePlanRequestDtoPriorityEnum];


/**
 * Check if a given object implements the UpdatePlanRequestDto interface.
 */
export function instanceOfUpdatePlanRequestDto(value: object): value is UpdatePlanRequestDto {
    return true;
}

export function UpdatePlanRequestDtoFromJSON(json: any): UpdatePlanRequestDto {
    return UpdatePlanRequestDtoFromJSONTyped(json, false);
}

export function UpdatePlanRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePlanRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'active': json['active'] == null ? undefined : json['active'],
        'schedulingHorizonDays': json['schedulingHorizonDays'] == null ? undefined : json['schedulingHorizonDays'],
    };
}

export function UpdatePlanRequestDtoToJSON(json: any): UpdatePlanRequestDto {
    return UpdatePlanRequestDtoToJSONTyped(json, false);
}

export function UpdatePlanRequestDtoToJSONTyped(value?: UpdatePlanRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'priority': value['priority'],
        'active': value['active'],
        'schedulingHorizonDays': value['schedulingHorizonDays'],
    };
}

